import { CommonModule } from "@angular/common";
import { ModuleWithProviders, NgModule } from "@angular/core";
import { ReactiveFormsModule } from "@angular/forms";
import { MatInputModule } from "@angular/material/input";
import { SharedUiModule } from "@dtm-frontend/shared/ui";
import { LanguageCode, SharedI18nModule, getTranslocoInlineLoader } from "@dtm-frontend/shared/ui/i18n";
import { TRANSLOCO_SCOPE } from "@jsverse/transloco";
import { LetModule, PushModule } from "@ngrx/component";
import { NgxsModule } from "@ngxs/store";
import { MapSearchComponent } from "./components/poi-search/map-search.component";
import { MapSearchApiService } from "./services/map-search-api.service";
import { MapSearchState } from "./state/map-search.state";

@NgModule({
    declarations: [MapSearchComponent],
    imports: [
        CommonModule,
        LetModule,
        PushModule,
        SharedI18nModule,
        SharedUiModule,
        MatInputModule,
        NgxsModule.forFeature([MapSearchState]),
        ReactiveFormsModule,
    ],
    exports: [MapSearchComponent],
    providers: [
        {
            provide: TRANSLOCO_SCOPE,
            multi: true,
            useValue: {
                scope: "dtmMapSearchLib",
                loader: getTranslocoInlineLoader((language: LanguageCode) => import(`./assets/i18n/${language}.json`)),
            },
        },
    ],
})
export class MapSearchModule {
    public static forTest(): ModuleWithProviders<MapSearchModule> {
        return {
            ngModule: MapSearchModule,
            providers: [
                {
                    provide: MapSearchApiService,
                    useValue: null,
                },
            ],
        };
    }
}
